// This file is automatically generated with create-ts-svgs script in package.json
import * as React from 'react'; 
			
interface ISvgProps {
	className?: string,
}
			
const fn: React.FunctionComponent<ISvgProps> = (props) => (
	<svg className={props.className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M13 13h10a1 1 0 100-2H13V1a1 1 0 00-2 0v10H1a1 1 0 100 2h10v10a1 1 0 102 0z"/></svg>
);

export default fn;
